import { type SearchDomainIndexName } from '~/apps/product-plus/search-domain/indexes';
import { getSearchPipelineDefinitionByIndex } from '~/apps/product-plus/search-domain/pipelineRegistry';
import { type SearchUiConfig, type SearchUiContext } from '~/apps/product-plus/search-domain/types';

export function getSearchConfig(
  indexName: SearchDomainIndexName,
  context: SearchUiContext,
): SearchUiConfig | undefined {
  const definition = getSearchPipelineDefinitionByIndex(indexName);
  if (!definition) return undefined;
  return definition.getSearchUiConfig(context);
}
